import dayjs from 'dayjs'

// Validate checkDate date: if it's before today, use today's date instead
export default function validateIsTodayDate(checkDate: string) {
    try {
      // Parse checkDate date using dayjs
      const validateIsTodayDate = dayjs(checkDate, 'YYYY/MM/DD');
      
      // Get today's date at the start of the day
      const today = dayjs().startOf('day');
      
      // Check if checkDate date is before today
      if (validateIsTodayDate.isBefore(today)) {
        // Use today's date formatted as 'YYYY/MM/DD'
        return dayjs().format('YYYY/MM/DD');
      }
      
      // Return the original checkDate date
      return checkDate;
    } catch (error) {
      // Handle the error here, such as logging or displaying an error message
      console.error('Error occurred during checkDate date validation:', error);
      // Return the original checkDate date in case of error
      return checkDate;
    }
  }
  